<div class="w-full h-full flex justify-center items-center">
  <h5 class="tui-text_h5">{{ 'Partner no auth' | translate }}</h5>
</div>
